import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet } from './api';
import {
  IProductConfigurationSummaryResponse,
  PRODUCT_CONFIGURATION_TRANSITION
} from '../types/product-configuration-summary.types';

const { REACT_APP_SUBSCRIPTION } = process.env;

/**
 * Obtiene el resumen de configuraciones de un servicio logístico.
 * @param logisticServiceId - ID del servicio logístico
 * @param transition - Transición opcional a evaluar
 */
export const getLogisticServiceConfigurationSummary = async (
  logisticServiceId: number | string,
  transition?: PRODUCT_CONFIGURATION_TRANSITION.LOGISTIC_SERVICE_ACTIVE
): Promise<IProductConfigurationSummaryResponse> => {
  const transitionQuery = transition ? `?transition=${transition}` : '';
  const url = `${REACT_APP_SUBSCRIPTION}/configurations/summary/logistic-service/${logisticServiceId}${transitionQuery}`;

  return apiGet<AxiosRequestConfig, IProductConfigurationSummaryResponse>(url)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Obtiene el resumen de configuraciones de un envío.
 * @param shipmentId - ID del envío
 * @param transition - Transición opcional a evaluar
 */
export const getShipmentConfigurationSummary = async (
  shipmentId: number | string,
  transition?: PRODUCT_CONFIGURATION_TRANSITION.SHIPMENT_TRANSIT_TO_DESTINATION
): Promise<IProductConfigurationSummaryResponse> => {
  const transitionQuery = transition ? `?transition=${transition}` : '';
  const url = `${REACT_APP_SUBSCRIPTION}/configurations/summary/shipment/${shipmentId}${transitionQuery}`;

  return apiGet<AxiosRequestConfig, IProductConfigurationSummaryResponse>(url)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
